import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f86f31f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("入力")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("詳細")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("詳細")

import { computed, onMounted, ref, watch } from 'vue'
  import { useStore } from "vuex";
  import { useRoute } from 'vue-router';
  import { ProjectAlertFormRepository } from "@/repositories/ProjectAlertFormRepository"
  import { useExceptionMessage } from '@/logic/ExceptionMessageLogic'

  interface AlertForm {
    project_alert_form_id: number;
    title: string;
    limited_at: string;
    completed: boolean;
  }
  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const route = useRoute();

  const alertFormLoading = ref(false);

  const store = useStore();
  const managerFlg = computed(() => store.state.login.manager_flg || store.state.login.project_owner_flg)
  const alertForms = ref<AlertForm[]>([])

  const load = async (project_id: number) => {
    const repository = new ProjectAlertFormRepository(project_id)

    alertFormLoading.value = true;

    try {
      alertForms.value = await repository.getList()

      alertFormLoading.value = false;
    } catch (e: any) {
      useExceptionMessage(e, "エラーが発生しました。<br>再読み込みしてお試しください");
    }
  };

  onMounted(async (): Promise<void> => {
    load(Number(route.params.project_id));
  });
  watch(() => route.params.project_id, async (project_id): Promise<void> => {
    if (project_id) {
      load(Number(project_id));
    }
  });

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_unref(managerFlg))
    ? (_openBlock(), _createBlock(_component_el_container, {
        key: 0,
        class: "container container__card"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_main, null, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_el_card, { class: "box-card" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table, { data: alertForms.value }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        prop: "title",
                        label: "フォーム名",
                        width: "180"
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "limited_at",
                        label: "入力期限",
                        width: "180"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "入力済",
                        width: "180"
                      }, {
                        default: _withCtx((scope) => [
                          _createTextVNode(_toDisplayString(scope.row.completed ? '済' : ''), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, { align: "right" }, {
                        default: _withCtx((scope) => [
                          _createVNode(_component_router_link, {
                            to: {name: 'InputProjectAlertForm', params: {project_alert_form_id: scope.row.project_alert_form_id}},
                            class: "button-link"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                type: "info",
                                round: ""
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_1
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["to"]),
                          (scope.row.completed)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: {name: 'ProjectAlertForm', params: {project_alert_form_id: scope.row.project_alert_form_id}},
                                class: "button-link ml10"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_button, { round: "" }, {
                                    default: _withCtx(() => [
                                      _hoisted_2
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            : (_openBlock(), _createBlock(_component_el_button, {
                                key: 1,
                                class: "ml10",
                                round: "",
                                disabled: !scope.row.completed
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_3
                                ]),
                                _: 2
                              }, 1032, ["disabled"]))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["data"])
                ]),
                _: 1
              }, 512), [
                [_directive_loading, alertFormLoading.value]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})